module.exports = __webpack_public_path__ + "static/media/PC1-1.d01cac0e.jpg";